import { useState, useEffect, useCallback, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useApi } from './useApi';
import { hasMultimoneda } from '../utils/multimoneda';

export function useFxRates() {
  const { user } = useContext(AuthContext);
  const { secureFetch } = useApi();
  const [rates, setRates] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const enabled = hasMultimoneda(user);

  const loadRates = useCallback(async () => {
    if (!enabled) return null;
    setLoading(true);
    setError('');
    try {
      const res = await secureFetch('/api/fx/rates');
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Error al cargar cotizaciones');
      setRates(data);
      return data;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled, secureFetch]);

  useEffect(() => {
    if (enabled) loadRates();
  }, [enabled, loadRates]);

  const getRateFor = useCallback(
    (moneda) => {
      if (!rates || !moneda || moneda === 'ARS') return 1;
      if (moneda === 'USD') return rates.rates?.USD?.tipoCambio ?? rates.rates?.blue;
      if (moneda === 'EUR') return rates.rates?.EUR?.tipoCambio ?? rates.rates?.eur;
      return null;
    },
    [rates]
  );

  return {
    enabled,
    rates,
    loading,
    error,
    preference: rates?.preference || 'blue',
    reload: loadRates,
    getRateFor,
  };
}

export default useFxRates;
